import React, {useState} from 'react';
import {useDispatch} from "react-redux";
import { Table, Tag, Tooltip, Popconfirm, Button } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import {deleteUserAppData} from "../api/userApi";


const AppDataCollection = ({ data, onSelect }) => {
  const dispatch = useDispatch();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const handleSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const onRemove = (items) => {
    dispatch(deleteUserAppData({ ids: items }));
  }

  const handleDelete = (item) => {
    onRemove([item.id]); // Adjust this as necessary for your backend API
  };

  const handleBatchDelete = () => {
    onRemove(selectedRowKeys);
    setSelectedRowKeys([]);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: handleSelectChange,
  };
  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: text => text || 'Unnamed Item',
    },
    {
      title: 'Type',
      dataIndex: 'app_type',
      key: 'app_type',
      render: app_type => <Tag color="blue">{app_type}</Tag>,
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, item) => (
        <Tooltip title="Remove">
          <CloseCircleOutlined onClick={(e) => {
            e.stopPropagation(); // Prevent Table row selection
            onRemove(item);
          }} />
        </Tooltip>
      ),
    },
    {
      title: "Created On",
      dataIndex: "create_unix",
      key: "create_unix",
      render: (create_unix) => new Date(create_unix * 1000).toLocaleString(),
    },
    {
      title: "Updated On",
      dataIndex: "update_unix",
      key: "update_unix",
      render: (create_unix) => new Date(create_unix * 1000).toLocaleString(),
    },
    {
      title: "Created By",
      dataIndex: "owner",
      key: "owner",


    }
  ];
  const hasSelected = selectedRowKeys.length > 0;

  return (
      <>
        <div style={{ marginBottom: 16 }}>
          <Popconfirm title="Sure to delete?" onConfirm={handleBatchDelete} disabled={!hasSelected}>
            <Button type="primary" disabled={!hasSelected}>
              Delete Selected
            </Button>
          </Popconfirm>
        </div>
        <Table
            className={'spaced'}
            rowSelection={rowSelection}
            columns={columns}
            dataSource={data}
            onRow={(record) => ({
              onClick: () => onSelect(record), // Handle row click
            })}
            rowKey="id" // Assuming each data item has a unique `id` property
        />
      </>
  );
};

export default AppDataCollection;
